
import React from 'react';
import { Course, User } from '@/types';
import { Button } from '@/components/ui/button';
import GameFormHeader from './GameFormHeader';
import { useCreateGame } from '@/hooks/useCreateGame';
import PlayerSelector from './PlayerSelector';

interface CreateGameFormProps {
  courses: Course[];
  onCreateGame: () => void;
  onCancel?: () => void;
  isLoadingCourses?: boolean;
  defaultCourseId?: string;
  defaultSelectedFriends?: User[];
}

const CreateGameForm: React.FC<CreateGameFormProps> = ({
  courses,
  onCreateGame,
  onCancel,
  isLoadingCourses = false,
  defaultCourseId,
  defaultSelectedFriends = [],
}) => {
  const {
    name,
    setName,
    courseId,
    setCourseId,
    bet,
    setBet,
    selectedFriends,
    isSubmitting,
    durationType,
    setDurationType,
    isRecurring,
    setIsRecurring,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    courseError,
    nameError,
    handleGolferSelect,
    handleGolferRemove,
    handleSubmit
  } = useCreateGame({
    onCreateGame,
    defaultCourseId,
    defaultSelectedFriends
  });

  return (
    <div className="px-4">
      <form onSubmit={handleSubmit}>
        <GameFormHeader
          name={name}
          setName={setName}
          courseId={courseId}
          setCourseId={setCourseId}
          bet={bet}
          setBet={setBet}
          durationType={durationType}
          setDurationType={setDurationType}
          isRecurring={isRecurring}
          setIsRecurring={setIsRecurring}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          courses={courses}
          isSubmitting={isSubmitting}
          isLoadingCourses={isLoadingCourses}
          nameError={nameError}
          courseError={courseError}
        />

        {/* Player Selection */}
        <PlayerSelector
          selectedPlayers={selectedFriends}
          onPlayerSelect={handleGolferSelect}
          onPlayerRemove={handleGolferRemove}
        />

        <div className="flex gap-2 justify-end">
          {onCancel && (
            <Button type="button" variant="outline" onClick={onCancel} disabled={isSubmitting}>
              Cancel
            </Button>
          )}
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Creating...' : 'Create Game'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CreateGameForm;
